import { useRef } from 'react';
import { useScroll, useTransform, useSpring } from 'motion/react';

interface ParallaxOptions {
  offset?: [string, string];
  outputRange?: [number, number];
  spring?: boolean;
}

export const useParallax = (options: ParallaxOptions = {}) => {
  const {
    offset = ['start end', 'end start'],
    outputRange = [60, -60],
    spring: applySpring = true,
  } = options;

  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: offset as any });
  const rawY = useTransform(scrollYProgress, [0, 1], outputRange);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const y = applySpring ? useSpring(rawY, { stiffness: 80, damping: 20 }) : rawY;

  return { ref, y, scrollYProgress };
};
